export default "__VITE_ASSET__B0XE5Dc3__"